import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import React, { ComponentProps } from 'react'
import styled from 'styled-components'
import Group from 'components/utils/Group'

const Scroller = styled(HorizontalContainerWithFadedOverflow)`
  box-shadow: inset 0 -1px 0 ${props => props.theme.palette.neutral.default.five};
`
type HorizontalContainerProps = Pick<ComponentProps<typeof HorizontalContainerWithFadedOverflow>, 'overflowGutter'>
interface Props extends React.HTMLAttributes<HTMLDivElement>, HorizontalContainerProps {
  /**
   * Describes how the tab children should be laid out
   * Grow will spread the tabs across the whole width of the group
   * Auto will make them only take up the room required per tab
   */
  fit?: 'auto' | 'grow'
  /**
   * @default fit
   */
  tabletFit?: 'auto' | 'grow'
  gap?: ComponentProps<typeof Group>['gap']
}

const TabButtonsGroup = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    children,
    fit = 'auto',
    tabletFit,
    ...restOfProps
  } = props

  return <Scroller
    {...restOfProps}
    horizontalAlign={fit === 'grow' ? 'stretch' : 'start'}
    tabletHorizontalAlign={(tabletFit ?? fit) === 'grow' ? 'stretch' : 'start'}
    ref={ref}
  >
    {children}
  </Scroller>
})

TabButtonsGroup.displayName = 'TabButtonsGroup'

export default TabButtonsGroup
